var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, FormController, FormLabel, Input, Link, LoadingButton, Modal, ModalBody, ModalHeader, Typography, } from '@one-thd/sui-atomic-components';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { bool } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { getFGsWithDeliveryTrackerReturnWindow } from '../../utils/returns/returns-fg-helper';
import { FeatureSwitches } from '../../constants/feature-switches';
import { getGuestOrderTracking } from '../../api/oms/guest-order-tracking';
import { guestOrderTrackingErrors } from '../../constants/guest-order-tracking-error';
import { GetDeliveryTrackerInfo } from '../../hooks/delivery-tracker-hooks';
import { handleDisableBtn, makeGuestRequestBody, } from '../../utils/guest-order-tracking-utils';
import { addPhoneHyphens } from '../../utils/order-history/form-utils';
import '../shared/ButtonFix.scss';
import { useCommonContext } from '../../hooks/useContexts';
export var TrackOrderForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var setFormData = _a.setFormData, setFormSubmitted = _a.setFormSubmitted, orderId = _a.orderId;
    var _j = useState(false), isLoading = _j[0], setLoading = _j[1];
    var _k = useState(false), openModal = _k[0], setOpenModal = _k[1];
    var _l = useState({
        orderNumber: '',
        phoneNumber: '',
        email: '',
    }), inputError = _l[0], setInputError = _l[1];
    var enableDeliveryTrackerReturnChanges = FeatureSwitches.enableDeliveryTrackerReturnChanges;
    var _m = useForm({
        mode: 'onBlur',
        defaultValues: {
            orderNumber: '',
            phoneNumber: '',
            email: '',
            tryAgain404: false,
        },
    }), clearErrors = _m.clearErrors, errors = _m.formState.errors, handleSubmit = _m.handleSubmit, register = _m.register, reset = _m.reset, setError = _m.setError, setValue = _m.setValue, watch = _m.watch;
    var watchOrderNumber = watch('orderNumber');
    var watchPhoneNumber = watch('phoneNumber');
    var watchEmail = watch('email');
    var theme = useTheme(TrackOrderForm);
    var hideOrderSignIn = theme.props.hideOrderSignIn;
    var timezone = useCommonContext().timezone;
    useEffect(function () {
        if (orderId !== 'null' && orderId !== '') {
            setValue('orderNumber', orderId);
        }
        if (watchOrderNumber.length === 10 ||
            watchOrderNumber.length === 11 ||
            watchOrderNumber.length === 12 ||
            watchOrderNumber.length === 13) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderNumber: 'success' })); });
            if (watchEmail.length > 0)
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { phoneNumber: 'success', email: 'success' })); });
            clearErrors();
        }
        if (inputError.orderNumber === 'success' &&
            (watchOrderNumber.length < 10 || watchOrderNumber.length > 12)) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderNumber: 'error' })); });
            setError('orderNumber', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchOrderNumber]);
    useEffect(function () {
        if (watchPhoneNumber.length === 12) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { phoneNumber: 'success', email: 'success' })); });
            clearErrors();
        }
        if (inputError.phoneNumber === 'success' &&
            watchPhoneNumber.length !== 12) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { phoneNumber: 'error' })); });
            setError('phoneNumber', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchPhoneNumber]);
    useEffect(function () {
        if (watchEmail.length > 6 && watchEmail.includes('.')) {
            if (watchEmail.includes('@')) {
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { phoneNumber: 'success', email: 'success' })); });
                if (watchOrderNumber.length > 0)
                    setInputError(function (prevState) { return (__assign(__assign({}, prevState), { orderNumber: 'success' })); });
                clearErrors();
            }
            else {
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { email: 'error' })); });
                setError('email', { type: 'invalid', message: 'invalid entry' });
            }
        }
        if (inputError.email === 'success' && watchEmail.length < 7) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { email: 'error' })); });
            setError('email', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchEmail]);
    var onFormSubmit = function (_a) {
        var orderNumber = _a.orderNumber, phoneNumber = _a.phoneNumber, email = _a.email;
        return __awaiter(void 0, void 0, void 0, function () {
            var request, response, status_1, deliveryTrackingData, updatedFulfillmentGroups, _error_1, error_1;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        clearErrors();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 9, 10, 11]);
                        setLoading(true);
                        request = void 0;
                        if (!(orderNumber && (phoneNumber || email))) return [3 /*break*/, 8];
                        request = makeGuestRequestBody(orderNumber, email, phoneNumber, timezone);
                        return [4 /*yield*/, getGuestOrderTracking(request)];
                    case 2:
                        response = _c.sent();
                        status_1 = response ? response.status : null;
                        if (status_1 === null) {
                            setError('tryAgain404', {
                                type: 'failed',
                                message: 'failed request',
                            });
                            return [2 /*return*/];
                        }
                        response.data.traceId = (_b = response.headers) === null || _b === void 0 ? void 0 : _b.traceid;
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, 6, 7]);
                        return [4 /*yield*/, GetDeliveryTrackerInfo(response.data)];
                    case 4:
                        deliveryTrackingData = _c.sent();
                        if (enableDeliveryTrackerReturnChanges && deliveryTrackingData) {
                            updatedFulfillmentGroups = getFGsWithDeliveryTrackerReturnWindow(deliveryTrackingData.fulfillmentGroups);
                            setFormData(__assign(__assign({}, deliveryTrackingData), { fulfillmentGroups: updatedFulfillmentGroups }));
                        }
                        else {
                            setFormData(deliveryTrackingData);
                        }
                        return [3 /*break*/, 7];
                    case 5:
                        _error_1 = _c.sent();
                        // If delivery tracking fails, just set the order details data
                        setFormData(response.data);
                        return [3 /*break*/, 7];
                    case 6:
                        setFormSubmitted(true);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                    case 8:
                        setError('tryAgain404', { type: 'failed', message: 'failed request' });
                        return [3 /*break*/, 11];
                    case 9:
                        error_1 = _c.sent();
                        // eslint-disable-next-line no-console
                        console.error(error_1);
                        return [3 /*break*/, 11];
                    case 10:
                        setLoading(false);
                        if (!('tryAgain404' in errors)) {
                            if (watchEmail.length > 0) {
                                setInputError({
                                    email: 'error',
                                    orderNumber: '',
                                    phoneNumber: '',
                                });
                                setError('orderNumber', { type: '404', message: 'invalid entry' });
                            }
                            else if (watchPhoneNumber.length > 0) {
                                setInputError({
                                    email: '',
                                    orderNumber: '',
                                    phoneNumber: 'error',
                                });
                                setError('orderNumber', { type: '404', message: 'invalid entry' });
                            }
                        }
                        else {
                            reset();
                        }
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    return (React.createElement("div", { className: "sui-flex sui-justify-center sui-mt-8" },
        React.createElement("div", { style: {
                width: '450px',
                height: '336px',
            }, className: "sui-flex sui-flex-col" },
            React.createElement(Typography, { variant: "h2" }, "Look up by Order Number"),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-8" },
                React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputError.orderNumber || ((errors === null || errors === void 0 ? void 0 : errors.orderNumber) && 'error') },
                    React.createElement(FormLabel, { htmlFor: "orderNumber" }, "Order Number"),
                    React.createElement(Input, __assign({ "aria-describedby": "orderNumber-input", fullWidth: true, id: "orderNumber", inputProps: {
                            maxLength: 13,
                        } }, register('orderNumber', {
                        required: true,
                        minLength: 9,
                        onChange: function (event) {
                            return setValue('orderNumber', event.target.value.toUpperCase());
                        },
                        onBlur: function (event) {
                            return setValue('orderNumber', event.target.value.toUpperCase());
                        },
                    }), { placeholder: "e.g. W123456789 or H0121-53379" })),
                    inputError.orderNumber === 'error' && (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-8 sui-mt-2" },
                        React.createElement(Typography, { variant: "body-xs", color: "danger" },
                            (['required', 'minLength', 'invalid', 'pattern'].includes((_c = (_b = errors === null || errors === void 0 ? void 0 : errors.orderNumber) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : 'invalid') ||
                                ((_d = errors === null || errors === void 0 ? void 0 : errors.orderNumber) === null || _d === void 0 ? void 0 : _d.type) === 'tryAgain') &&
                                guestOrderTrackingErrors.orderNumberNotFound,
                            React.createElement("br", null),
                            (['required', 'minLength', 'invalid', 'pattern'].includes((_f = (_e = errors === null || errors === void 0 ? void 0 : errors.orderNumber) === null || _e === void 0 ? void 0 : _e.type) !== null && _f !== void 0 ? _f : 'invalid') ||
                                inputError.orderNumber === 'error') &&
                                guestOrderTrackingErrors.onlineOrdersInvalidFormat,
                            React.createElement("br", null),
                            (['required', 'minLength', 'invalid', 'pattern'].includes((_h = (_g = errors === null || errors === void 0 ? void 0 : errors.orderNumber) === null || _g === void 0 ? void 0 : _g.type) !== null && _h !== void 0 ? _h : 'invalid') ||
                                inputError.orderNumber === 'error') &&
                                guestOrderTrackingErrors.instoreOrdersInvalidFormat),
                        React.createElement(Typography, { variant: "body-xs" },
                            "You can find your order number in your confirmation email or your",
                            ' ',
                            React.createElement(Link, { onClick: function () { return setOpenModal(true); }, variant: "body-xs" }, "in-store receipt"))))),
                watchOrderNumber[0] === 'H' && (React.createElement(FormController, { fullWidth: true, status: inputError.phoneNumber || ((errors === null || errors === void 0 ? void 0 : errors.phoneNumber) && 'error') },
                    React.createElement(FormLabel, { htmlFor: "phoneNumber" }, "Phone"),
                    React.createElement(Input, __assign({ "aria-describedby": "phoneNumber-input", fullWidth: true, id: "phoneNumber", inputProps: {
                            maxLength: 12,
                        } }, register('phoneNumber', {
                        required: true,
                        minLength: 12,
                        pattern: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
                        onChange: function (event) {
                            return setValue('phoneNumber', addPhoneHyphens(event.target.value));
                        },
                        onBlur: function (event) {
                            return setValue('phoneNumber', addPhoneHyphens(event.target.value));
                        },
                    }), { placeholder: "(        )         -" })),
                    (inputError.phoneNumber === 'error' || errors.phoneNumber) && (React.createElement("div", { className: "sui-mt-2" },
                        React.createElement(Typography, { variant: "body-xs", color: "danger" }, guestOrderTrackingErrors.tryAgainPhone))))),
                (watchOrderNumber[0] === 'W' || watchOrderNumber[0] === 'C') && (React.createElement(FormController, { fullWidth: true, status: inputError.email || ((errors === null || errors === void 0 ? void 0 : errors.email) && 'error') },
                    React.createElement(FormLabel, { htmlFor: "email" }, "Email"),
                    React.createElement(Input, __assign({ "aria-describedby": "email-input", fullWidth: true, id: "email" }, register('email', {
                        required: true,
                        minLength: 7,
                        pattern: /^.+@[^.].*\.[a-zA-Z]{2,}$/,
                        onChange: function (event) {
                            return setValue('email', event.target.value);
                        },
                        onBlur: function (event) {
                            return setValue('email', event.target.value);
                        },
                    }), { placeholder: "you@domain.com" })),
                    (inputError.email === 'error' || errors.email) && (React.createElement("div", { className: "sui-mt-2" },
                        React.createElement(Typography, { variant: "body-xs", color: "danger" }, guestOrderTrackingErrors.tryAgainEmail))))),
                React.createElement("div", { className: "ButtonGroup sui-min-w-full sui-flex sui-gap-3 sui-flex-col md:sui-flex-row lg:sui-flex-row" },
                    React.createElement(LoadingButton, { disabled: handleDisableBtn(errors, inputError), onClick: handleSubmit(onFormSubmit), variant: "primary", loading: isLoading }, "Track Order")),
                !hideOrderSignIn && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "sui-flex sui-justify-between sui-items-center" },
                        React.createElement("div", { style: {
                                height: '1px',
                                width: '12rem',
                                backgroundColor: '#999',
                            } }),
                        React.createElement(Typography, { variant: "body-base", align: "center" }, "Have an account with us?"),
                        React.createElement("div", { style: {
                                height: '1px',
                                width: '12rem',
                                backgroundColor: '#999',
                            } })),
                    React.createElement("div", { className: "ButtonGroup sui-min-w-full sui-flex sui-gap-3 sui-flex-col md:sui-flex-row lg:sui-flex-row" },
                        React.createElement(Button, { href: "https://www.homedepot.com/auth/view/signin?redirect=/order/view/summary", variant: "secondary" }, "Sign in to Your Account")),
                    React.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                        } },
                        React.createElement(Link, { href: "https://www.homedepot.com/c/PH_MyAccount", target: "_blank", variant: "body-xs", align: "center" }, "My Account Terms & Conditions"),
                        React.createElement(Typography, { variant: "body-base" }, " | "),
                        React.createElement(Link, { href: "https://www.homedepot.com/c/Privacy_Security", target: "_blank", variant: "body-xs", align: "center" }, "Privacy & Security Statement")))))),
        React.createElement(Modal, { open: openModal, onClose: function () { return setOpenModal(false); }, size: "sm" },
            React.createElement(ModalHeader, { onClose: function () { return setOpenModal(false); } },
                React.createElement(Typography, { variant: "h4" }, "Finding Your Order & Phone Numbers")),
            React.createElement(ModalBody, null,
                React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/instore-help.png", alt: "Receipt Example", width: "592px", height: "312px" })))));
};
TrackOrderForm.displayName = 'TrackOrderForm';
TrackOrderForm.themeProps = {
    hideOrderSignIn: bool,
};
TrackOrderForm.defaultThemeProps = {
    hideOrderSignIn: false,
};
